import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FeedbacksData.css';
import { CSVLink } from "react-csv";
import Moment from 'moment';

function FeedbackData() {
    const [feedbacks, setFeedbacks] = useState([]);
    const [dataInCSV, setDataInCSV] = useState("");

    const handleDataforDownload = () => {
        let updatedDownloadData = dataInCSV.map((feedback, idx) => {
            return {
                'SL#': idx + 1,
                'Enterprise Id': feedback.enterprise_id,
                'comment': feedback.comment,
                'Submitted Date': `${Moment(feedback.created_at).format('DD-MM-YYYY')}`,

            };
        })
        setDataInCSV(updatedDownloadData);
    }

    const fetchData = async () => {
        try {
            let response = await axios({
                method: 'get',
                url: 'https://atci.lkm.eitacademy.accenture.com/ips-apis/feedback',
                headers: {
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                }
            })
            setFeedbacks(response.data.results);
            setDataInCSV(response.data.results);
        } catch (error) {
            // console.log(error);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className='feedback-admin'>
            <h2>LKM Feedbacks</h2>
            <table>
                <thead>
                    <tr>
                        <th>SL#</th>
                        <th>Enterprise Id</th>
                        <th>Comment</th>
                        <th>feedback submitted date</th>
                    </tr>
                </thead>
                <tbody>
                    {feedbacks.length > 0 ? feedbacks.map((feedback, idx) => {
                        return <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{feedback.enterprise_id}</td>
                            <td>{feedback.comment !== '' ? feedback.comment : '-'}</td>
                            <td>{feedback.created_at.split('T')[0]}</td>
                        </tr>
                    }) : <tr><td colspan="5">No Feedbacks Found </td></tr>}
                </tbody>
            </table>
            <div className='sap_feedback_download'>
                Click to download feedbacks :&nbsp;
                <CSVLink filename={"sap-feedbacks.csv"} data={dataInCSV} onClick={handleDataforDownload}>Download</CSVLink>
            </div>
        </div>
    )
}

export default FeedbackData;